import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { ExcelService } from '../../services/excel.service';
import { MenuService } from '../../services/menu.service';

/* global require, window, Office, console, localStorage */

const URL_MAPPER = {
  PROD: 'https://api.inercomp.com/v1',
  STAGING: 'https://api-staging.inercomp.com/v1',
  DEV: 'https://emsa.icservice.inercomp.com/v1',
  TESTING: 'https://api-preprod.ictesting.inercomp.com/v1'
};

@Component({
  selector: 'app-header',
  template: require('./header.component.html'),
})
export class HeaderComponent implements OnInit {
  inWebsite = false;
  query_period: any;
  jump_to_next_cell: boolean = false;

  @Output() config_changed = new EventEmitter<Event>();
  @Output() restoreClicked = new EventEmitter<Event>();

  constructor(
    @Inject(ExcelService) private excelService: ExcelService,
    @Inject(MenuService) private menuService: MenuService
  ) {}

  ngOnInit(): void {
    if (
      Office.context.platform !== Office.PlatformType.PC &&
      Office.context.platform !== Office.PlatformType.OfficeOnline
    ) {
      this.inWebsite = true;
    }
    this.query_period = localStorage.getItem('preferred_query_period');
    const lsJumpToNextCell = localStorage.getItem('feeder_jump_to_next_cell');
    this.jump_to_next_cell = lsJumpToNextCell !== null && JSON.parse(lsJumpToNextCell);
  }

  updateFunctions() {
    this.excelService.updateFunctions().catch((error) => console.error(error));
  }

  setBackend(backend = 'PROD') {
    const oldUrl = window.api_url;
    window.api_url = URL_MAPPER[backend];
    this.config_changed.emit();
    if (oldUrl !== window.api_url) {
      this.menuService.loadMenu();
    }
  }

  restoreDefaults() {
    this.restoreClicked.emit();
  }

  clearFavorites() {
    localStorage.removeItem('favorites');
    this.config_changed.emit();
  }

  setQueryPeriod(periodString: string) {
    this.query_period = periodString;
    localStorage.setItem('preferred_query_period', periodString);
  }

  switchJumpToNextCell() {
    this.jump_to_next_cell = !this.jump_to_next_cell;
    localStorage.setItem('feeder_jump_to_next_cell', JSON.stringify(this.jump_to_next_cell));
  }

  logout() {
    localStorage.removeItem('feeder_sso');
    window.location.reload();
  }

  refreshMenu() {
    this.menuService.loadMenu(true);
  }
}
